(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/info/components/similar-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/info/components/similar-games.js');
"use strict";


const {
  useEffect
} = React;
const SimilarGames = _ref => {
  let {
    game,
    onLoaded
  } = _ref;
  const {
    loading,
    games = []
  } = svs.eInstant.shared.hooks.useGamesByTags({
    game
  });
  const {
    TicketsRowWrapper
  } = svs.eInstant.shared.components;
  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [loading]);
  if (loading || !games.length && !loading) {
    return null;
  }
  const category = {
    title: 'Liknande spel',
    games,
    icon: 'tips'
  };
  return React.createElement(TicketsRowWrapper, {
    category: category
  });
};
setGlobal('svs.eInstant.lobby.info.components.SimilarGames', SimilarGames);

 })(window);